import { FaWifi, FaHeadset, FaDollarSign, FaTv, FaSignal, FaInfinity } from 'react-icons/fa';

const features = [
  {
    id: 1,
    icon: <FaWifi />, // Wifi icon
    title: 'High-Speed Internet',
    description: 'Experience lightning-fast internet speeds, perfect for streaming, gaming, and working from home.',
  },
  {
    id: 2,
    icon: <FaHeadset />, // Headset icon
    title: '24/7 Customer Support',
    description: 'Our support team is available anytime to help you with any service-related issues.',
  },
  {
    id: 3,
    icon: <FaDollarSign />, // Dollar Sign icon
    title: 'Affordable Packages',
    description: 'Choose from a range of budget-friendly packages designed to fit every need and budget.',
  },
  {
    id: 4,
    icon: <FaTv />, // TV icon
    title: 'HD Cable TV',
    description: 'Watch your favorite channels in crystal-clear HD with flexible channel options.',
  },
  {
    id: 5,
    icon: <FaSignal />, // Signal icon
    title: 'Reliable Connection',
    description: 'Enjoy uninterrupted service with our highly reliable network infrastructure.',
  },
  {
    id: 6,
    icon: <FaInfinity />, // Infinity icon
    title: 'Unlimited Data',
    description: 'Stream, browse, and download as much as you want with our unlimited data plans.',
  },
];

export default features;